<template>
  <CategoryConsumptionPage
    :consumption_category_id="5"
    :showFuelGasAndDieselChart="false"
    :colors="{ primary: '#8DA1B9', secondary: '#A6B6C9' }"
    :consumption_category="{ name: 'water', unit: { text: 'Gal.' } }"
  >
  </CategoryConsumptionPage>
</template>

<script>
import CategoryConsumptionPage from '@/components/consumption/CategoryConsumptionPage';
export default {
  name: 'WaterConsumptionPage',
  components: { CategoryConsumptionPage },
};
</script>

<style scoped></style>
